module.exports = __webpack_public_path__ + "img/bigTruck-dark-grey.ddda8cc8.svg";